import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ServicingCommonStoreService } from '@common/services';
import { ServiceRequestPaymentInputService } from '@common/services/service-request-payment-input/service-request-payment-input-service';
import { SupportComponent } from '@lib/components/support-class';
import { StaticMsgPipe } from '@lib/pipes';
import { CommonLibService } from '@lib/services';
import { Subscription, take } from 'rxjs';
import { GetOrderResponseDataTravelersSummaryTravelerNumbers } from 'src/sdk-servicing';

@Component({
  selector: 'asw-payment-details-summary',
  templateUrl: './payment-details-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentDetailsSummaryComponent extends SupportComponent {
  private subscriptions: Subscription = new Subscription();
  public passengerNumberDisplayText: string = '';

  public totalAmount: number = 0;

  public isMexico: boolean = false;

  get travelerNumbers(): GetOrderResponseDataTravelersSummaryTravelerNumbers | undefined {
    return this._serviceRequestPaymentInputService.pnr$.value?.travelersSummary?.travelerNumbers;
  }

  constructor(
    private _common: CommonLibService,
    public changeDetectorRef: ChangeDetectorRef,
    private _staticMsg: StaticMsgPipe,
    private _serviceRequestPaymentInputService: ServiceRequestPaymentInputService,
    private _servicingCommonStoreService: ServicingCommonStoreService
  ) {
    super(_common);
  }

  init(): void {
    this.subscriptions.add(
      this._servicingCommonStoreService
        .getServicingCommonModel$()
        .pipe(take(1))
        .subscribe((servicingCommon) => {
          this.totalAmount =
            // サービシング共通store.ラウンジ情報.合計金額+
            (servicingCommon.chargeableLounge?.totalAmount! ?? 0) +
            // サービシング共通store.事前追加手荷物.合計金額 +
            (servicingCommon.firstBaggage?.totalAmount! ?? 0) +
            // サービシング共通store.機内食情報.合計金額+
            (servicingCommon.meal?.totalAmount! ?? 0) +
            // サービシング共通store.事前座席指定.合計金額
            (servicingCommon.seatReservationStatus?.totalAmount! ?? 0);
        })
    );
    // [9.2] 合計金額

    // [9.4] PNR情報取得API応答.data.travelersSummary.travelerNumber.ADT >= 1の場合、人数を表示する。
    if (this.travelerNumbers?.ADT && this.travelerNumbers?.ADT >= 1) {
      this.passengerNumberDisplayText += this._staticMsg.transform('label.passengerAdult', {
        '0': this.travelerNumbers?.ADT,
      });
    }
    // [9.5] PNR情報取得API応答.data.travelersSummary.travelerNumber.B15 >= 1の場合、人数を表示する。
    if (this.travelerNumbers?.B15 && this.travelerNumbers?.B15 >= 1) {
      this.passengerNumberDisplayText += this._staticMsg.transform('label.passengerYoungAdult', {
        '0': this.travelerNumbers?.B15,
      });
    }
    // [9.6] PNR情報取得API応答.data.travelersSummary.travelerNumber.CHD >= 1の場合、人数を表示する。
    if (this.travelerNumbers?.CHD && this.travelerNumbers?.CHD >= 1) {
      this.passengerNumberDisplayText += this._staticMsg.transform('label.passengerChild', {
        '0': this.travelerNumbers?.CHD,
      });
    }
    // [9.7] PNR情報取得API応答.data.travelersSummary.travelerNumber.INF >= 1の場合、人数を表示する。
    if (this.travelerNumbers?.INF && this.travelerNumbers?.INF >= 1) {
      this.passengerNumberDisplayText += this._staticMsg.transform('label.passengerInfant', {
        '0': this.travelerNumbers?.INF,
      });
    }
    // [9.8] PNR情報取得API応答.data.travelersSummary.travelerNumber.INS >= 1の場合、人数を表示する。
    if (this.travelerNumbers?.INS && this.travelerNumbers?.INS >= 1) {
      this.passengerNumberDisplayText += this._staticMsg.transform('label.passengerIns', {
        '0': this.travelerNumbers?.INS,
      });
    }
    // [9.9] 購入サービスの税金額注釈ラベル
    // ユーザ共通情報.POS国コード=”MX”(メキシコ)の場合、有料サービスの料金額には税金が含まれる旨の注釈文言を表示する。
    this.isMexico = this._common.aswContextStoreService.aswContextData.posCountryCode === 'MX';
  }

  reload(): void {
    /* override abstract reload function of base class */
  }

  destroy(): void {
    /* override abstract destroy function of base class */
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
